import {
  ClinicalLogSection,
  OcsMonitorSection,
  OrganSpecificSection,
  RadiometerSection,
} from '@features/components/ClinicalData/sections';
import { ClinicalItemLog, WithPerfusionTime } from '@features/components/ClinicalData/types';
import { ClinicalCaseProvider } from '@features/contexts/ClinicalCaseContext';
import { CaseStatus, ClinicalData, DonorType, OrganType } from '@/api/apis/case';

export type ClinicalDataTabProps = {
  donorType: DonorType;
  status: CaseStatus;
  organType: OrganType;
  clinicalData: ClinicalData;
  isTrialCase: boolean;
  clinicalDataItems: WithPerfusionTime<ClinicalItemLog>[];
  sectionColor: string;
  hasChatPermission?: boolean;
  isScs?: boolean;
};

export const ClinicalDataTabBase = ({
  donorType,
  status,
  organType,
  clinicalData,
  isTrialCase,
  clinicalDataItems,
  sectionColor,
  hasChatPermission = false,
  isScs = false,
}: ClinicalDataTabProps) => {
  return (
    <ClinicalCaseProvider isScs={isScs}>
      <div className="gap-3 2xl:overflow-y-hidden h-full grid 2xl:grid-cols-[2fr_1fr] 2xl:grid-rows-1 grid-rows-auto grid-cols-1 overflow-y-auto">
        <div className="flex flex-col gap-3 2xl:overflow-y-auto">
          <OrganSpecificSection
            organType={organType}
            donorType={donorType}
            clinicalData={clinicalData}
            status={status}
            isTrialCase={isTrialCase}
          />
          <OcsMonitorSection organType={organType} clinicalData={clinicalData} />
          <RadiometerSection organType={organType} clinicalData={clinicalData} />
        </div>
        <div className="shrink-0">
          <ClinicalLogSection
            organType={organType}
            clinicalData={clinicalData}
            isTrialCase={isTrialCase}
            clinicalDataItems={clinicalDataItems}
            sectionColor={sectionColor}
            hasChatPermission={hasChatPermission}
          />
        </div>
      </div>
    </ClinicalCaseProvider>
  );
};
